function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRfq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.3,
    height: 17.5,
    viewBox: "0 0 14.3 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "clipboard (3)",
    transform: "translate(-3.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 157",
    d: "M13.6 4h1.6a1.6 1.6 0 0 1 1.6 1.6v11.2a1.6 1.6 0 0 1-1.6 1.6H5.6A1.6 1.6 0 0 1 4 16.8V5.6A1.6 1.6 0 0 1 5.6 4h1.6",
    transform: "translate(0 -.4)",
    style: {
      fill: "none",
      stroke: "#6c7b8b",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 261",
    width: 6.4,
    height: 3.2,
    rx: 1,
    transform: "translate(7.2 2)",
    style: {
      fill: "none",
      stroke: "#6c7b8b",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfq);
export default __webpack_public_path__ + "static/media/rfq.bf8172369d57faebe245e2c271083a58.svg";
export { ForwardRef as ReactComponent };